var _rect, _rect2, _rect3, _path, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8418,
    y: 12.9785,
    width: 28.9492,
    height: 28.9492,
    rx: 4.78743,
    transform: "rotate(45 29.8418 12.9785)",
    fill: "#0198FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1211,
    y: 17.0703,
    width: 23.1626,
    height: 23.1626,
    rx: 3.82994,
    transform: "rotate(45 43.1211 17.0703)",
    fill: "#00CAB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5273 21.6641L44.8956 28.0323C46.7915 29.9282 47.7394 30.8762 48.0946 31.9693C48.407 32.9308 48.407 33.9665 48.0946 34.9281C47.7394 36.0212 46.7915 36.9691 44.8956 38.865L38.5272 45.2334L31.0757 37.7818C29.559 36.2651 28.8006 35.5068 28.5165 34.6323C28.2666 33.8631 28.2666 33.0345 28.5165 32.2652C28.8006 31.3908 29.559 30.6324 31.0757 29.1157L31.0757 29.1157L38.5273 21.6641Z",
    fill: "#A644F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8418,
    y: 21.457,
    width: 16.9581,
    height: 16.9581,
    rx: 2.87246,
    transform: "rotate(45 29.8418 21.457)",
    fill: "#017EC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2885 40.9946L38.5832 36.7L38.5832 36.7C39.7207 35.5624 40.2895 34.9937 40.5026 34.3378C40.69 33.7609 40.69 33.1394 40.5026 32.5625C40.2895 31.9067 39.7207 31.3379 38.5832 30.2003L38.5831 30.2003L34.2871 25.9043L31.0757 29.1157L31.0757 29.1157C29.559 30.6324 28.8006 31.3908 28.5165 32.2652C28.2666 33.0345 28.2666 33.8631 28.5165 34.6323C28.8006 35.5068 29.559 36.2651 31.0757 37.7818L34.2885 40.9946Z",
    fill: "#2A3E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon1);
export default __webpack_public_path__ + "static/media/IntegrationsIcon1.bee37806660191d22836a526d4296dc1.svg";
export { ForwardRef as ReactComponent };